module.exports = __webpack_public_path__ + "static/media/order_cancel.f5d9d16c.png";